import { SettingsSection } from '@components'

import { Button, Space, Text } from '@billy/design-system'
import { useTranslation } from 'react-i18next'

import { SettingsRoute } from '../../../../../../enums/settingsRoute'

export const SalesTaxReturnSection = () => {
  const { t } = useTranslation()

  return (
    <SettingsSection>
      <SettingsSection.Content title={t('settings.organization.accounting.sales_tax_return_settings')}>
        <Text colorVariant="secondary">{t('settings.organization.accounting.sales_tax_return_settings.subtext')}</Text>
        <Space size="s16" />
        <Button variant="outlined" to={SettingsRoute.OrganizationAccountingVatReturn}>
          {t('settings.organization.accounting.sales_tax_return_settings.edit')}
        </Button>
      </SettingsSection.Content>
    </SettingsSection>
  )
}
